export enum TenantSectorEnum {
  PUBLIC = 'public',
  PRIVATE = 'private',
  CHAMBER = 'chamber'
}

export const tenantSectorLabels = {
  [TenantSectorEnum.PUBLIC]: 'Público',
  [TenantSectorEnum.PRIVATE]: 'Privado',
  [TenantSectorEnum.CHAMBER]: 'Câmara',
}